<template>
    <div class="float-container--bottom">
        <button class="btn btn-secondary btn-lg btn-heavy" @click="OnChangeToUnavailable">
            <span v-if="settings && settings.invertir_movil_libre_no_disponible" v-lang.noDisponible>No disponible</span>
            <span v-else v-lang.movilLibre>Móvil libre</span>
        </button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dialogs from '@/services/dialogs';
import moment from 'moment';
import { showCancelModal } from '@/services/utility';

export default {
    name: 'driverReadyForService',
    props: [

    ],
    data () {
        return {
            price: ''
        };
    },
    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            currentPosition: 'geolocation/actual',
            settings: 'company/config',
            missedTrips: 'driver/missedTrips',
            canceledTrip: 'driver/canceledTrip',
            cancelReasonModuleEnabled: 'company/cancelReasonModuleEnabled',
            isDriver: 'auth/isChofer'
        })
    },
    mounted () {
        this.language = this.$getLang();
        this.onMissingTrips();
        console.log('canceledTrip mounted', this.canceledTrip);
        if (this.canceledTrip) {
            this.onCanceledTrip(this.canceledTrip);
        }
    },
    methods: {
        ...mapActions({
            changeAvailability: 'driver/changeAvailability',
            ignoreTrip: 'driver/ignoreTripPostAppearence',
            markAsAlerted: 'driver/markAsAlerted',
            caceledViewed: 'driver/cancelarVisto'
        }),
        OnChangeToUnavailable () {
            let vm = this;
            dialogs.confirm(this.translate('advertenciaCambiarANoDisponible'), function (index) {
                if (index === 1) {
                    vm.changeAvailability(false);
                }
            });
        },
        onMissingTrips () {
            console.log('missed trips', this.missedTrips);
            if (this.missedTrips && this.missedTrips.length) {
                let vm = this;
                this.missedTrips.forEach(trip => {
                    console.log('tripToAlert', trip);
                    if (trip && !trip.alertedMissing) {
                        let date = moment(trip.created_at).format('HH:mm');
                        let mensaje = date + ' - ' + trip.calle + ' ' + (trip.altura >= 0 ? trip.altura : '') + ': ';
                        if (trip.chofer_id) {
                            mensaje += ' Fue tomado por otro taxista';
                        } else {
                            mensaje += ' La solicitud fue retirada';
                        }
                        let options = {
                            isForgettable: false,
                            isModal: false,
                            callback: () => {
                                let data = {
                                    lat: 0,
                                    lng: 0,
                                    viaje_id: trip.id,
                                    comentario: 'IGNORADO TARDE',
                                    date: trip.created_at
                                };
                                vm.ignoreTrip(data);
                            }
                        };
                        vm.markAsAlerted(trip);
                        vm.$alertForgettable('missed_trip_' + trip.id, mensaje, options);
                    }
                });
            }
        },
        onCanceledTrip (trip) {
            console.log('onCanceledTrip', trip);
            /* let reason = this.translate('viajeCaneladoPorPasajero');
            reason += this.cancelReasonModuleEnabled ? (this.translate('reason') + trip.comentario_rechazo) : '';
            let date = moment(trip.created_at).format('HH:mm');
            let mensaje = date + ' - ' + trip.calle + ' ' + (trip.altura > 0 ? trip.altura : '') + ': ';
            mensaje += reason;
            let options = {
                isForgettable: false,
                isModal: false,
                callback: () => {}
            };
            if (trip.razon_cancelacion) {

            }
            this.markAsAlerted(trip);
            this.$alertForgettable('canceled_trip_' + trip.id, mensaje, options);
            this.caceledViewed(trip.id); */
            showCancelModal.call(this, trip);
        }

    },
    watch: {
        missedTrips () {
            this.onMissingTrips();
        },
        canceledTrip (oldValue, newValue) {
            console.log('canceledTrip watcher', oldValue, newValue);
            if (newValue) {
                if (!oldValue || (oldValue.id !== newValue.id)) {
                    let trip = newValue;
                    this.onCanceledTrip(trip);
                }
            }
        }
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/driver/OnReadyForService.vue